var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10061",
    "data-name": "Group 10061",
    transform: "translate(-950 -710)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_574",
    "data-name": "Ellipse 574",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(950 710)",
    fill: "#002147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "microphone-svgrepo-com",
    transform: "translate(963.605 722.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7959",
    "data-name": "Path 7959",
    d: "M7,8.184a5.774,5.774,0,0,1,11.548,0v6.929A5.774,5.774,0,1,1,7,15.113Z",
    transform: "translate(0.619)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7960",
    "data-name": "Path 7960",
    d: "M23.787,13.41A10.394,10.394,0,1,1,3,13.41",
    transform: "translate(0 1.703)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneUnchecked);
export default __webpack_public_path__ + "static/media/microphone-unchecked.5d841cb7572a63ad68adfc2066b2c40c.svg";
export { ForwardRef as ReactComponent };